import script from "./DevelopMinView.vue?vue&type=script&setup=true&lang=js"
export * from "./DevelopMinView.vue?vue&type=script&setup=true&lang=js"

import "./DevelopMinView.vue?vue&type=style&index=0&id=5e18d9b3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e18d9b3"]])

export default __exports__